import { render, staticRenderFns } from "./IdCell.vue?vue&type=template&id=15878649&scoped=true&"
import script from "./IdCell.vue?vue&type=script&lang=ts&"
export * from "./IdCell.vue?vue&type=script&lang=ts&"
import style0 from "./IdCell.vue?vue&type=style&index=0&id=15878649&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15878649",
  null
  
)

export default component.exports